<div class="container-fluid">
  <page-header-search
    [isSearchInput]="false"
    [pageTitleValue]="pageTitle"
  ></page-header-search>

  <div class="card">
    <div class="card-body">
      <form
        [formGroup]="appointmentsForm"
        (ngSubmit)="onFormSubmit()"
      >
        <div class="row">
          <div class="form-group d-inline-block col-12 col-md-7">
            <label class="form-control-label" for="search">
              Search
            </label>
            <div class="form-group">
              <input
                formControlName="search"
                class="search form-control"
                type="text"
                name="search"
                placeholder="Search By Patient Name or Psp code or Mobile Number or National ID or Passport ID"
              />
            </div>
            
          </div>
          <div class="form-group d-inline-block col-12 col-md-3">
            <div class="form-group">
              <label class="form-control-label" for="appointment-duration">
                Duration
              </label>
              <input
                type="text"
                class="form-control"
                id="appointment-duration"
                bsDaterangepicker
                formControlName="appointmentDuration"
                [bsConfig]="{
                  isAnimated: true,
                  containerClass: 'theme-blue'
                }"
                name="bsDaterangepicker"
              />
            </div>
          </div>
          <div class="col-12 col-md-2 d-inline-block form-group">
            <button
              type="submit"
              class="btn btn-neutral col-12 bg-blue text-white submit-btn"
            >
              Search
            </button>
          </div>
        </div>
      </form>
      <div class="row">
        <div class="col-12 status-filter-btns">
          <h5 class="filter">Filter By</h5>
          <div class="filter-btn-container">
            <button 
              class="btn btn-filter"
              [ngClass]="{
                'selected': isActiveStatus('0'),
                'active-filter-btn': isActiveStatus('0')
              }"
              (click)="onSearchAppointment('0')"
            >
              All
            </button>
            <button 
              class="btn btn-filter"
              [ngClass]="{
                'selected': isActiveStatus('1'),
                'active-filter-btn': isActiveStatus('1')
              }"
              (click)="onSearchAppointment('1')"
            >
              Pending
            </button>
            <button 
              class="btn btn-filter"
              [ngClass]="{
                'selected': isActiveStatus('2'),
                'active-filter-btn': isActiveStatus('2')
              }"
              (click)="onSearchAppointment('2')"
            >
              Finished
            </button>
            <button 
              class="btn btn-filter"
              [ngClass]="{
                'selected': isActiveStatus('3'),
                'active-filter-btn': isActiveStatus('3')
              }"
              (click)="onSearchAppointment('3')"
            >
              Cancelled
            </button>
            <button 
              class="btn btn-filter"
              [ngClass]="{
                'selected': isActiveStatus('8'),
                'active-filter-btn': isActiveStatus('8')
              }"
              (click)="onSearchAppointment('8')"
            >
              Active
            </button>
            <button 
              class="btn btn-filter"
              [ngClass]="{
                'selected': isActiveStatus('9'),
                'active-filter-btn': isActiveStatus('9')
              }"
              (click)="onSearchAppointment('9')"
            >
              Patient NoShow
            </button>
            <button 
              class="btn btn-filter"
              [ngClass]="{
                'selected': isActiveStatus('10'),
                'active-filter-btn': isActiveStatus('10')
              }"
              (click)="onSearchAppointment('10')"
            >
              Doctor NoShow
            </button>
            <button 
              class="btn btn-filter"
              [ngClass]="{
                'selected': isActiveStatus('11'),
                'active-filter-btn': isActiveStatus('11')
              }"
              (click)="onSearchAppointment('11')"
            >
              Received PassCode
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="!allAppointmentsArray.length">
    <div class="col-12 text-center py-5">Hmm, There are no appointments 🥳</div>
  </div>

  <div *ngIf="allAppointmentsArray.length" class="card">
    <div class="card-body">
      <div class="table-title">
        <div class="table-title-actions">
            <h3 class="title mb-0">
              {{ selectedTab }} 
              <span *ngIf="selectedTab !== 'Received Passcode'">Appointments</span>
            </h3>          <button class="btn btn-neutral" (click)="ExportTOExcel()">
            <span class="btn-inner--icon">
              <i class="ni ni-cloud-download-95"> </i>
            </span>
            <span class="btn-inner--text"> Download as Excel </span>
          </button>
        </div>
      </div>

      <ngx-datatable class="material ngx-datatable-custom" [rows]="allAppointmentsArray"
        [columns]="columns" [limit]="pageSize" [offset]="currentPage-1"
        columnMode="force" externalPaging="true" [count]="totalItems" [scrollbarH]="true"
        [headerHeight]="50" [footerHeight]="50" rowHeight="auto" (page)="onChangePage($event)"
        selectionType="single" (select)="onAppointmentDetails($event)" [messages]="messages">
        <ng-template let-row="row" #patientNameRef ngx-datatable-row-detail-template>
          <span *ngIf="!row.isAnonymous">{{ row.patientName | uppercase }}</span>
        </ng-template>
        <ng-template let-row="row" #displayNameRef ngx-datatable-row-detail-template>
          <span *ngIf="row.isAnonymous">{{ row.displayName | uppercase }}</span>
        </ng-template>
        
      </ngx-datatable>
    </div>
  </div>
</div>